import React from 'react';
import PropTypes from 'prop-types';
import AuthoringTextInput from 'client/EditPage/V2/AuthoringTextInput/AuthoringTextInput.react';
import SupplementManagerModalButton from 'client/Supplements/SupplementManager/SupplementManagerModalButton.react';
import {AuthoringQuestionModelV1} from 'resources/augmented/AuthoringQuestion/AuthoringQuestionModel.v1';

export class FreeResponseEditor extends React.Component {
  static propTypes = {
    question: PropTypes.instanceOf(AuthoringQuestionModelV1),
    onModelChange: PropTypes.func
  };

  onChange = (e) => {
    const updatedQuestion = this.props.question.setSample(e.target.value);
    this.props.onModelChange(updatedQuestion);
  };

  render() {
    return (
      <div className='u-display_flex u-flex-direction_column'>
        <AuthoringTextInput
          className='sample-solution'
          label='Sample Response'
          name='sample'
          onChange={this.onChange}
          placeholder='A powerful sample of the solution'
          value={this.props.question.getSample()}
        />
        <SupplementManagerModalButton
          className='question-editor__add-supplement-btn u-mar-t_2'
          pathToProperty='sample'
        />
      </div>
    );
  }
}
